"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _carouselImages = _interopRequireDefault(require("../styles/carousel-images.css"));
var ProgressNumbers = function ProgressNumbers(_ref) {
  var visibleImageIndex = _ref.visibleImageIndex,
    carouselImagesLength = _ref.carouselImagesLength,
    theme = _ref.theme,
    slidesDoubled = _ref.slidesDoubled;
  /* eslint-disable */
  carouselImagesLength = slidesDoubled ? 2 : carouselImagesLength;
  var digitsToRoundTo = -2;
  var formatNumbers = function formatNumbers(number) {
    if (slidesDoubled) {
      return ("0" + (number > 2 ? Math.floor(number * 0.5) : number)).slice(digitsToRoundTo);
    }
    return ("0" + number).slice(digitsToRoundTo);
  };
  var currentNumber = formatNumbers(visibleImageIndex + 1);
  var maxNumber = formatNumbers(carouselImagesLength);
  return /*#__PURE__*/_react["default"].createElement("p", {
    className: theme.labelSmall + " " + _carouselImages["default"].controlNumbers
  }, /*#__PURE__*/_react["default"].createElement("span", null, currentNumber), maxNumber != 0 && /*#__PURE__*/_react["default"].createElement("img", {
    src: "data:image/svg+xml,%3Csvg width='12' height='17' viewBox='0 0 12 17' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.384.639l1.732 1-8.5 14.722-1.732-1z' fill='%23000' fill-rule='evenodd'/%3E%3C/svg%3E",
    alt: "/",
    className: _carouselImages["default"].controlsSlash
  }), maxNumber != 0 && /*#__PURE__*/_react["default"].createElement("span", null, maxNumber));
};
var _default = ProgressNumbers;
exports["default"] = _default;